import { createContext } from "react";

// Entity members available for the People/Owner picker on the current board.
export const BoardMembersContext = createContext([]);

export const uid = () => Math.random().toString(36).slice(2, 10);

export const COLUMN_CHOICES = [
  { type: "status", label: { fr: "Statut", en: "Status" } },
  { type: "text", label: { fr: "Texte", en: "Text" } },
  { type: "number", label: { fr: "Nombre", en: "Number" } },
  { type: "date", label: { fr: "Date", en: "Date" } },
  { type: "timeline", label: { fr: "Échéancier", en: "Timeline" } },
  { type: "people", label: { fr: "Personne", en: "People" } },
  { type: "dropdown", label: { fr: "Liste", en: "Dropdown" } },
  { type: "priority", label: { fr: "Priorité", en: "Priority" } },
  { type: "checkbox", label: { fr: "Case", en: "Checkbox" } },
  { type: "progress", label: { fr: "Progression", en: "Progress" } },
];

export const GROUP_COLORS = ["#3B82F6", "#22C55E", "#F59E0B", "#EF4444", "#A855F7", "#14B8A6", "#EC4899", "#6366F1", "#9CA3AF"];

// Hover affordance so users see a field is editable before clicking.
export const EDIT_HOVER = "rounded-md border border-transparent hover:border-[color:var(--border-strong)] transition-colors";

export const tint = (hex, a) => {
  const h = (hex || "#3B82F6").replace("#", "");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
};

export function defaultOptionsFor(type) {
  if (type === "status") {
    return [
      { id: "todo", label: "To do", color: "#9CA3AF" },
      { id: "in_progress", label: "Working on it", color: "#3B82F6" },
      { id: "stuck", label: "Stuck", color: "#EF4444" },
      { id: "done", label: "Done", color: "#22C55E", done: true },
    ];
  }
  if (type === "priority") {
    return [
      { id: "low", label: "Low", color: "#9CA3AF" },
      { id: "medium", label: "Medium", color: "#3B82F6" },
      { id: "high", label: "High", color: "#F59E0B" },
      { id: "critical", label: "Critical", color: "#EF4444" },
    ];
  }
  if (type === "dropdown") {
    return [{ id: "a", label: "Option A", color: "#6366F1" }, { id: "b", label: "Option B", color: "#14B8A6" }];
  }
  return [];
}
